<template>
  <div>
    <el-dialog
      :visible="isOpen"
      :show-close="true"
      :before-close="cancel"
      title="替换素材"
      top="10vh"
    >
      <div style="padding-bottom: 30px">
        <div>
          <el-select
            v-if="material_format.type === 'select'"
            v-model="material_format.value"
            :placeholder="material_format.placeholder"
            v-bind="material_format.props"
            v-on="material_format.on"
          >
            <el-option
              v-for="(item, index) in material_format.options"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <br>
        <el-upload
          ref="upload"
          action=""
          :auto-upload="false"
          multiple
          :disabled="material_format.value ? false : true"
          :on-change="handleFileChange"
        >
          <el-button
            :disabled="material_format.value ? false : true"
            size="small"
            plain
            type="primary"
          >点击上传</el-button>
          <div v-if="material_format.value" slot="tip" class="el-upload__tip">
            <p v-if="restriction.type !== 3">宽高：{{ restriction.width }} * {{ restriction.height }}</p>
            <p>只能上传{{ restriction.mime_type.join('/') }}文件，且不超过{{ (restriction.type === 2 ? restriction.max_size : max_size)/1024 }}M</p>
            <p>上传现在数量：{{ restriction.num }}</p>
          </div>
        </el-upload>
        <br>
        <div class="dialog-footer">
          <el-button :loading="is_loading" size="small" type="primary" @click="submitUpload">替换</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 素材库上传
import MaterialResource from '@/api/material/index';
const materialResource = new MaterialResource();

// 素材规格列表接口
import MaterialFormatResource from '@/api/material/format';
const materialFormatResource = new MaterialFormatResource();

export default {
  props: {
    /** 是否打开弹框 */
    isOpen: {
      type: Boolean,
      default: false,
    },
    /** 素材类型 */
    type: {
      type: Number,
      default: 1,
    },
    /** 素材ID */
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      is_loading: false,
      /** 素材提交参数 */
      material_params: {
        /**
         * 本地素材 ID
         * @type undefined|number
         * @default undefined
         */
        local_material_id: undefined,

        /**
         * 素材规格 ID
         * @type undefined|number
         * @default undefined
         */
        material_format_id: undefined,

        /**
         * 素材类别，1图片，2视频，3落地页
         * @type undefined|number
         * @default undefined
         */
        material_type: undefined,

        /**
         * 素材文件数组
         * @type undefined|Array<File>
         * @default undefined
         */
        materials: undefined,
      },
      // 素材规格列表参数
      material_format_list_params: {
        page: 1,
        limit: 10,
      },
      /** 最大尺寸 */
      max_size: 3072,
      /** 限制 */
      restriction: {},
      /** 素材规格列表 */
      material_format_list: [],
      /** 素材标准选择器配置 */
      material_format: {
        label: '素材标准',
        placeholder: '请输入素材标准',
        type: 'select',
        options: [],
        value: null,
        required: true,
        props: {
          filterable: true,
          size: 'mini',
        },
        on: {
          change: (val) => {
            this.material_params.material_format_id = val;
            this.restriction = this.material_format_list.filter((item) => {
              return item.id === val;
            })[0];
          },
        },
      },
    };
  },
  created() {
    this.material_params.local_material_id = this.id;
    this.material_params.material_type = this.type;

    this.material_format_list_params['type'] = this.type;
    // 获取素材规格列表
    this.getMaterialFormatList(this.material_format_list_params).then((res) => {
      this.material_format_list = res.list;
      this.material_format.options = res.list.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      this.material_format.value = null;
    });
  },
  methods: {
    /** 提交上传 */
    submitUpload() {
      const params = this.material_params;
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        if (typeof params[key] === 'object') {
          for (const item_key in params[key]) {
            formData.append(key + '[' + item_key + ']', params[key][item_key]);
          }
        } else if (params[key]){
          formData.append(key, params[key]);
        }
      });
      this.updateMaterial(formData).then(() => {
        this.confirm();
      });
    },
    /** 上传文件变化事件 */
    handleFileChange(file, file_list) {
      const is_video = this.restriction.type === 2;
      const show_file = is_video ? document.createElement('video') : new Image();
      if (this.verify(file.raw)) {
        if (is_video) {
          file.type = 'video';
          show_file.addEventListener('loadedmetadata', () => {
            const temp_duration = show_file.duration * 1000;
            // 验证视频时长是否符合
            if (temp_duration <= this.restriction.min_millisecond || temp_duration >= this.restriction.max_millisecond) {
              this.$message.error('视频时长≥' + this.restriction.min_millisecond + 's，视频时长≤' + this.restriction.max_millisecond + 's');
              return;
            }
            // 验证验证大小尺寸是否符合
            if (!this.verifySize(show_file.videoWidth, show_file.videoHeight)) {
              deleFile();
              return;
            } else {
              this.file_arr = file_list;
            }
          });
        } else {
          file.type = 'image';
          show_file.onload = () => {
            if (!this.verifySize(show_file.width, show_file.height)) {
              deleFile();
              return;
            } else {
              this.material_params.materials = file_list.map((item) => {
                return item.raw;
              });
            }
          };
        }
        show_file.src = URL.createObjectURL(file.raw);
      } else {
        deleFile();
        return;
      }

      /** 删除文件 */
      function deleFile() {
        const index = file_list.indexOf(file);
        file_list.splice(index, 1);
      }
      this.material_params.materials = file_list.map((item) => {
        return item.raw;
      });
    },
    /** 验证 */
    verify(file) {
      const is_type = !this.verifyType(file.type);
      const file_size = this.restriction.type === 2 ? this.restriction.max_size : this.max_size;
      const is_file_size = file.size / 1024 < file_size;
      let is_corre = true;

      if (!is_type) {
        is_corre = false;
        this.$message.error('上传文件只能是 ' + this.restriction.mime_type + ' 格式!');
      } else if (!is_file_size) {
        is_corre = false;
        this.$message.error(
          '上传文件大小不能超过 ' + file_size + 'kb!'
        );
      }

      return is_corre;
    },
    /** 验证大小尺寸 */
    verifySize(width, height) {
      let is_size = false;
      const isWidth = this.restriction.width === 0 ? true : width === this.restriction.width;
      const isHeigth = this.restriction.height === 0 ? true : height === this.restriction.height;
      if (isWidth && isHeigth && isWidth === true && isHeigth === true) {
        is_size = true;
      }
      if (!is_size) {
        this.$message.error('上传文件尺寸大小不符合要求');
      }
      return is_size;
    },
    /** 验证文件类型 */
    verifyType(type) {
      let is_err = true;
      const type_arr = this.restriction.mime_type.map((item) => {
        return this.restriction.type === 2 ? 'video/' + item : 'image/' + item;
      });
      for (var i = 0; i < type_arr.length; i++) {
        const temp_type = type_arr[i];
        if (temp_type === type) {
          is_err = false;
        }
      }
      return is_err;
    },
    /** 取消 */
    cancel() {
      this.$emit('cancel');
    },
    /** 确定 */
    confirm() {
      this.$emit('confirm');
    },
    /** 获取素材规格列表 */
    getMaterialFormatList(params) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .getMaterialFormatListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 更新素材 */
    updateMaterial(params) {
      this.is_loading = true;
      return new Promise((resolve, reject) => {
        materialResource
          .updateMaterialApi(params)
          .then(response => {
            this.$message({
              message: '替换成功！',
              type: 'success',
            });
            resolve(response);
          })
          .catch(error => {
            reject(error);
          }).finally(() => {
            this.is_loading = false;
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: absolute;
  bottom: 0px;
  left: 0px;
  padding: 20px;
  right: 0px;
  text-align: right;
}
</style>
